/* eslint-disable import/namespace , no-nested-ternary */
import React, { useCallback, useEffect, useMemo } from 'react';
import CommonDialog from 'components_newui/dialogs/CommonDialog';
import { ReactFormGenerator } from 'components_newui/formBuilder/react-form-builder-innovate/src/index';
import TagSelector from '../EvaluationSuggestion';
import TableCard from '../components/table_card/View';
import EvaluationPopupForm from './EvaluationPopupForm';
import IdeaApprove from './IdeaApprove';
import { useMeanIdeaRating } from './useMeanIdeaRating';
import BusinessScorecardList from './BusinessScorecardList';
import { useIdeaSplit } from '../hook/useIdeaSplit';

const Dialogs = ({
  ideaIdKey,
  challengeKey,
  loginUserEmail,
  dialogOpen,
  setDialogOpenApprove,
  dialogOpenApprove,
  dialogEvaluatorOpen,
  dialogEvaluatorRateOpen,
  setDialogOpen,
  setDialogEvaluatorOpen,
  setDialogEvaluatorRateOpen,
  dialogEvaluatorShowAllOpen,
  setDialogEvaluatorShowAllOpen,
  dialogScoreCardShowAllOpen,
  setDialogScoreCardShowAllOpen,
  childValueSelectedUserTags,
  handleChildValueChange,
  onCommunityValueChange,
  communityValueChange,
  handleConfirm,
  handleCommunitySearchConfirm,
  evaluationLoading,
  userEvaluatorSuggestions,
  searchByCommunityUserInnovateIdeaSuggestions,
  onUserEvaluatorSearchSuggestions,
  onUserEvaluatorSearchByCommunitySuggestions,
  formDataScorecardTemplate,
  allRequerstParamsSendToAPI,
  postInnovateIdeaEvaluatorRatingSaveFn,
  putInnovateIdeaEvaluatorRatingSubmitFn,
  putInnovateIdeaEvaluatorRatingEditFn,
  onHandleViewScorecard,
  onRemoveEvalutor,
  evaluators,
  DeleteAssignedEvaluatorIdeaIsLoading,
  getJsonEvaluatorForRatingIsLoading,
  postInnovateIdeaApproveFn,
  postApproveIdeaIsLoading,
  getJsonEvaluatorForRating,
  selectedEvaluator,
  handleEvaluatorClick,
  isAdmin,
  isInnovator,
  isOrganizer,
  isEvaluator,
  isHackathonChallenge,
  dialogOpenForTeamSearchAdd,
  setDialogOpenForTeamSearchAdd,
  handleAddTeamMemberConfirm,
  onInviteTeamMemberFn,
  postInnovateIdeaScorecardSaveRatingIsLoading,
  getShowPopupEvaluatorScorecardDataFn,
  getShowPopupEvaluatorScorecardDataResponse,
  dialogOpenBusinessScorecard,
  setDialogOpenBusinessScorecard,
  listScorecardTemplateLoading,
  listScorecardTemplate,
  putAddBusinessScoreCardFn,
  innovateAddBusinessScoreCardIsLoading,
  ArrayOfObjDoubleScorecard,
  ChallengeTemplateId,
  businessScoreCardTemplateId,
  handleChildValueOnChangeDBSC,
  innovateUserIsEvaluatorOrNot,
  filteredDataGetListEvaluatorAssignedIdea,
  setDialogBusinessScoreCardShowAllOpen,
  dialogBusinessScoreCardShowAllOpen,
  setDialogBusinessEvaluatorShowAllOpen,
  dialogBusinessEvaluatorShowAllOpen,
  listCommunitesChallenge,
  showPopupScorecardIsLoading,
  defaultMode = "user",
  isOwner
}) => {

  // console.log("filteredDataGetListEvaluatorAssignedIdea== dailog", filteredDataGetListEvaluatorAssignedIdea)
  const [searchMode, setSearchMode] = React.useState(defaultMode);
  const [holdSelectedScorcardValue, setHoldSelectedScorcardValue] = React.useState('');
  const [dialogOpenRateEvaluatorScorecard, setDialogOpenRateEvaluatorScorecard] = React.useState(false)
  const [dialogOpenRateBusinessScorecard, setDialogOpenRateBusinessScorecard] = React.useState(false)
  // const [updateScorecardQuestionBasedOnClickButton, setUpdateScorecardQuestionBasedOnClickButton] = React.useState('')
  const [basedOnSelectRatingdataShowOnScorecardPopup, setBasedOnSelectRatingdataShowOnScorecardPopup] = React.useState({})
  const [basedOnSelectRatingdataShowOnBusinessPopup, setBasedOnSelectRatingdataShowOnBusinessPopup] = React.useState({})
  // const ideaSplit = useIdeaSplit(filteredDataGetListEvaluatorAssignedIdea);
  const ideaSplit = useIdeaSplit(evaluators);

  // Stable payload for popup/action
  const objUserAndIdeaID = useMemo(() => {
    return {
      ideaId: String(ideaIdKey ?? ""),
      userEmail: String(loginUserEmail ?? "").toLowerCase(),
    };
  }, [ideaIdKey, loginUserEmail]);

  const onHandleEvaluateScorecard = useCallback(
    async (getjsonRatingParams) => {
      // console.log("when click on single evaluator than show data and print---", getjsonRatingParams);
      const businessSCFlagResponse = getjsonRatingParams?.businessScoreCardFlag
      // Preconditions
      if (!ideaIdKey || !loginUserEmail || !businessSCFlagResponse) {
        // Optionally show a toast/snackbar here; we simply return for now
        return;
      }
      const payload = {
        ...objUserAndIdeaID,
        businessSCFlag: businessSCFlagResponse
      }
      try {
        if (!showPopupScorecardIsLoading) {
          await getShowPopupEvaluatorScorecardDataFn(payload);
          setDialogOpenRateEvaluatorScorecard((prev) => !prev);
        }
      } catch (err) {
        console.error("Failed to fetch evaluator scorecard data:", err);
      }
      // if (ideaIdKey && loginUserEmail && businessSCFlagResponse) {
      //   // Call the popup/action with the minimal payload 
      //  await getShowPopupEvaluatorScorecardDataFn(payload);
      // }
    },
    [
      ideaIdKey,
      loginUserEmail,
      // businessSCFlagResponse,
      objUserAndIdeaID,
      getShowPopupEvaluatorScorecardDataFn,
    ]
  );

  useEffect(() => {
    // if (getShowPopupEvaluatorScorecardDataResponse) {
    // setBasedOnSelectRatingdataShowOnScorecardPopup(getShowPopupEvaluatorScorecardDataResponse);
    // setBasedOnSelectRatingdataShowOnBusinessPopup(getShowPopupEvaluatorScorecardDataResponse)
    // }


    if (getShowPopupEvaluatorScorecardDataResponse) {
      setBasedOnSelectRatingdataShowOnScorecardPopup(getShowPopupEvaluatorScorecardDataResponse);
      setBasedOnSelectRatingdataShowOnBusinessPopup(getShowPopupEvaluatorScorecardDataResponse);
    } else {
      setBasedOnSelectRatingdataShowOnScorecardPopup(null);
      setBasedOnSelectRatingdataShowOnBusinessPopup(null);
    }


  }, [getShowPopupEvaluatorScorecardDataResponse]);

  // console.log("getShowPopupEvaluatorScorecardDataResponse ==>", getShowPopupEvaluatorScorecardDataResponse)


  // const onHandleEvaluateScorecard = (getjsonRatingParams)=>{
  //   console.log('when click on single evaluator than show data and print---',getjsonRatingParams)
  //   // const updateQuestionJson = getjsonRatingParams?.scoreCardJson?.value

  //     if (getIdeaIdFromURL && loginUserEmail && businessSCFlag) {
  //       getShowPopupForEvaluatorScorecardAssignedIdeaFn(objUserAndIdeaID);
  //     }
  //   }, [getIdeaIdFromURL, loginUserEmail, businessSCFlag]);

  //   setBasedOnSelectRatingdataShowOnScorecardPopup(getjsonRatingParams)
  //   setDialogOpenRateEvaluatorScorecard(!dialogOpenRateEvaluatorScorecard)
  // }

  const onHandleEvaluateOpenRateBusinessScorecard = useCallback(
    async (getjsonRatingParams) => {
      // console.log("when click on single evaluator than show data and print---", getjsonRatingParams);
      const businessSCFlagResponse = getjsonRatingParams?.businessScoreCardFlag
      // Preconditions
      if (!ideaIdKey || !loginUserEmail || !businessSCFlagResponse) {
        // Optionally show a toast/snackbar here; we simply return for now
        return;
      }
      const payload = {
        ...objUserAndIdeaID,
        businessSCFlag: businessSCFlagResponse
      }
      try {
        if (!showPopupScorecardIsLoading) {
          await getShowPopupEvaluatorScorecardDataFn(payload);
          setDialogOpenRateBusinessScorecard((prev) => !prev);
        }
      } catch (err) {
        console.error("Failed to fetch evaluator scorecard data:", err);
      }
      // if (ideaIdKey && loginUserEmail && businessSCFlagResponse) {
      //   // Call the popup/action with the minimal payload 
      //  await getShowPopupEvaluatorScorecardDataFn(payload);
      // }
    },
    [
      ideaIdKey,
      loginUserEmail,
      // businessSCFlagResponse,
      objUserAndIdeaID,
      getShowPopupEvaluatorScorecardDataFn,
    ]
  )

  // const onHandleEvaluateOpenRateBusinessScorecard = (getjsonRatingParams)=>{
  //   console.log("when click business scorecard get details to print on popup ))))))))=>,", getjsonRatingParams)
  //   //when click on bussinness scorecard we are take obj and inside pickup Question 
  //   // const updateQuestionJson = getjsonRatingParams?.scoreCardJson?.value
  //   // setUpdateScorecardQuestionBasedOnClickButton(updateQuestionJson)
  //   setBasedOnSelectRatingdataShowOnBusinessPopup(getjsonRatingParams)
  //   setDialogOpenRateBusinessScorecard(!dialogOpenRateBusinessScorecard)
  // }





  const onChangeDropdownSelectValua = (dropdwonSelectedValue) => {
    setHoldSelectedScorcardValue(dropdwonSelectedValue)
  }

  const { mean, count } = useMeanIdeaRating(ideaSplit.eIdeas);
  const { mean: b_mean, } = useMeanIdeaRating(ideaSplit.bIdeas);
  const overallRating = Math.round(mean)
  const B_overallRating = Math.round(b_mean)
  const handleSearchModeFnCall = searchMode === 'user' ? handleConfirm : handleCommunitySearchConfirm



  // 1. Safely check E-type ideas using optional chaining and .some()
  const hasMatchingUserEvaluator = Array.isArray(ideaSplit?.eIdeas)
    ? ideaSplit.eIdeas.some(item => item?.userEmail === loginUserEmail)
    : (console.warn("ideaSplit.eIdeas is not a valid array."), false);

  // 2. Safely check Business-type ideas using optional chaining and .some()
  const hasMatchingUserEvaluatorForBusiness = Array.isArray(ideaSplit?.bIdeas)
    ? ideaSplit.bIdeas.some(item => item?.userEmail === loginUserEmail)
    : (console.warn("ideaSplit.bIdeas is not a valid array."), false);


  const disableAssignBtn = searchMode === 'user' ? !childValueSelectedUserTags?.length : false
  const disableAssignBtn1 = (typeof communityValueChange === 'string') ?? false


  if (getJsonEvaluatorForRatingIsLoading) {
    return 'Loading..'
  }


  // console.log("searchMode==> type", searchMode, communityValueChange?.label !== '')
  // console.log("holdSelectedScorcardValue==> onChange ",holdSelectedScorcardValue , !(holdSelectedScorcardValue !=='') && !(communityValueChange !=='') )


  // console.log("check template id selected default  123123123123==>", ChallengeTemplateId)
  // console.log("check template id selected default  businesscard 123123123123==>", businessScoreCardTemplateId)

  return (
    <>
      {/* Assign Approve Dialog */}
      <CommonDialog
        open={dialogOpenApprove}
        title="Approve Idea"
        // confirmText="Approve"
        cancelText="Close"
        hideSubmitBtn
        content={
          <IdeaApprove
            ideaIdKey={ideaIdKey}
            postIdeaApproveAPIfn={postInnovateIdeaApproveFn}
            postApproveIdeaIsLoading={postApproveIdeaIsLoading}
            innovateUserIsEvaluatorOrNot={innovateUserIsEvaluatorOrNot}
            onEvaluateScorecard={onHandleEvaluateScorecard}
            onEvaluateBusinessScorecard={onHandleEvaluateOpenRateBusinessScorecard}
            filteredDataGetListEvaluatorAssignedIdea={filteredDataGetListEvaluatorAssignedIdea}
            setDialogOpenApprove={setDialogOpenApprove}
            isHackathonChallenge={isHackathonChallenge}
            showPopupScorecardIsLoading={showPopupScorecardIsLoading}
          // postIdeaApproveAPIfn={postInnovateIdeaApproveFn}
          // postApproveIdeaIsLoading={postApproveIdeaIsLoading}
          />
        }
        onClose={() => setDialogOpenApprove(false)}
      />

      {/* Assign Evaluator Dialog */}
      {/* {console.log("handleChildValueOnChangeDBSC==>", handleChildValueOnChangeDBSC)} */}
      <CommonDialog
        open={dialogOpen}
        title="Assign Evaluator"
        confirmText="Assign"
        hideSubmitBtn={false}
        content={
          <TagSelector
            isLoading={evaluationLoading}
            inputLabel="Search Assign Evaluator..."
            onValueChange={handleChildValueChange}
            onCommunityValueChange={onCommunityValueChange}
            getSuggestionsAPI={onUserEvaluatorSearchSuggestions}
            getSuggestionsAPIFromSearchByCommunity={onUserEvaluatorSearchByCommunitySuggestions}
            suggestionsList={userEvaluatorSuggestions}
            suggestionsListByCommunity={searchByCommunityUserInnovateIdeaSuggestions}
            onChangeDropdownSelectValua={onChangeDropdownSelectValua}
            ArrayOfObjDoubleScorecard={ArrayOfObjDoubleScorecard}
            ChallengeTemplateId={ChallengeTemplateId}
            businessScoreCardTemplateId={businessScoreCardTemplateId}
            handleChildValueOnChangeDBSC={handleChildValueOnChangeDBSC}
            isHackathonChallenge={isHackathonChallenge}
            listCommunitesChallenge={listCommunitesChallenge}
            searchMode={searchMode}
            setSearchMode={setSearchMode}
          />
        }
        onClose={() => { setDialogOpen(false); setHoldSelectedScorcardValue('') }}
        onConfirm={handleSearchModeFnCall}
        disabled={isHackathonChallenge ? (searchMode === 'user' ? !childValueSelectedUserTags?.length : !(communityValueChange !== '')) : searchMode === 'user' ? !(holdSelectedScorcardValue !== '') || !childValueSelectedUserTags?.length : !(holdSelectedScorcardValue !== '') || !(communityValueChange !== '')} // dropdown not select than disble assign button
      />



      {/* Rate Scorecard Dialog */}
      <CommonDialog
        open={dialogOpenRateEvaluatorScorecard}
        title="Rate Evaluator Scorecard"
        cancelText="Close"
        hideSubmitBtn
        content={showPopupScorecardIsLoading ? 'Evaluator Scorecard rating loading...' :
          <EvaluationPopupForm
            jsonData={basedOnSelectRatingdataShowOnScorecardPopup?.scoreCardJson?.value || []}
            ideaIdKey={ideaIdKey}
            challengeKey={challengeKey}
            loginUserEmail={loginUserEmail}
            handleEvaluatorRatingSave={postInnovateIdeaEvaluatorRatingSaveFn}
            handleEvaluatorRatingEdit={putInnovateIdeaEvaluatorRatingEditFn}
            getJsonEvaluatorForRating={basedOnSelectRatingdataShowOnScorecardPopup}
            getJsonEvaluatorForRatingIsLoading={getJsonEvaluatorForRatingIsLoading}
            isHackathonChallenge={isHackathonChallenge}
          />
        }
        onClose={() => setDialogOpenRateEvaluatorScorecard(false)}
      />

      {/* Rate Scorecard Dialog  if IsHackthon Challenge is True than show this popup  */}
      <CommonDialog
        open={dialogEvaluatorRateOpen}
        title="Rate Scorecard"
        cancelText="Close"
        hideSubmitBtn

        content={
          <EvaluationPopupForm
            getJsonEvaluatorForRating={getJsonEvaluatorForRating}
            challengeKey={challengeKey}
            ideaIdKey={ideaIdKey}
            loginUserEmail={loginUserEmail}
            getJsonEvaluatorForRatingIsLoading={postInnovateIdeaScorecardSaveRatingIsLoading}
            jsonData={formDataScorecardTemplate || []}
            // sendRequerstParams={allRequerstParamsSendToAPI}
            handleEvaluatorRatingEdit={putInnovateIdeaEvaluatorRatingEditFn}
            handleEvaluatorRatingSubmit={putInnovateIdeaEvaluatorRatingSubmitFn}
            handleEvaluatorRatingSave={postInnovateIdeaEvaluatorRatingSaveFn}
            setDialogEvaluatorRateOpen={setDialogEvaluatorRateOpen}
            isHackathonChallenge={isHackathonChallenge}
          />
        }
        onClose={() => setDialogEvaluatorRateOpen(false)}
      />


      {/* Rate Business Scorecard Dialog */}
      <CommonDialog
        open={dialogOpenRateBusinessScorecard}
        title="Rate Business Scorecard"
        cancelText="Close"
        hideSubmitBtn
        content={showPopupScorecardIsLoading ? 'Business scorecard rating loading...' :
          <EvaluationPopupForm
            jsonData={basedOnSelectRatingdataShowOnBusinessPopup?.scoreCardJson?.value || []}
            ideaIdKey={ideaIdKey}
            challengeKey={challengeKey}
            loginUserEmail={loginUserEmail}
            handleEvaluatorRatingSave={postInnovateIdeaEvaluatorRatingSaveFn}
            handleEvaluatorRatingEdit={putInnovateIdeaEvaluatorRatingEditFn}
            getJsonEvaluatorForRating={basedOnSelectRatingdataShowOnBusinessPopup}
            getJsonEvaluatorForRatingIsLoading={getJsonEvaluatorForRatingIsLoading}
            isHackathonChallenge={isHackathonChallenge}
          />
        }
        onClose={() => setDialogOpenRateBusinessScorecard(false)}
      />


      {/* View All Evaluator */}
      <CommonDialog
        open={dialogEvaluatorShowAllOpen}
        // title="Evaluators 1"
        title="Evaluators"
        cancelText='Close'
        hideSubmitBtn
        content={
          <TableCard
            isAdmin={isAdmin}
            // isInnovator={isInnovator}
            isOrganizer={isOrganizer}
            title="Evaluators"
            header={["E-mail", "Action"]}
            data={ideaSplit.eIdeas}
            onClick={onRemoveEvalutor}
            disabled={DeleteAssignedEvaluatorIdeaIsLoading}
            hideShowAll
          />
        }
        onClose={() => setDialogEvaluatorShowAllOpen(false)}
      />

      {/* View All Scorecard */}
      <CommonDialog
        open={dialogScoreCardShowAllOpen}
        title={`Scorecard Overall Rating - ${overallRating}%`}
        cancelText='Close'
        hideSubmitBtn
        content={
          <TableCard
            // title="Scorecard Rating "
            // title={`'Scorecard Rating - overallRating' - ${overallRating}%`}
            // isInnovator={isInnovator}
            header={["E-mail", "Rating", "Action"]}
            data={ideaSplit.eIdeas}
            HideEyeIconForOtherEvaluator={hasMatchingUserEvaluator}
            loginUserEmail={loginUserEmail}
            isEvaluator={isEvaluator}
            isAdmin={isAdmin}
            isOrganizer={isOrganizer}
            onClick={handleEvaluatorClick}
            disabled={DeleteAssignedEvaluatorIdeaIsLoading}
            hideShowAll
          />
        }
        onClose={() => setDialogScoreCardShowAllOpen(false)}
      />


      {/* View  All Business Evaluator */}
      <CommonDialog
        open={dialogBusinessEvaluatorShowAllOpen}
        // title="Evaluators 1"
        title="Business Evaluators"
        cancelText='Close'
        hideSubmitBtn
        content={
          <TableCard
            isAdmin={isAdmin}
            isOrganizer={isOrganizer}
            title="Business Evaluators"
            header={["E-mail", "Action"]}
            data={ideaSplit.bIdeas}
            onClick={onRemoveEvalutor}
            disabled={DeleteAssignedEvaluatorIdeaIsLoading}
            hideShowAll
          />
        }
        onClose={() => setDialogBusinessEvaluatorShowAllOpen(false)}
      />

      {/* View All Business Scorecard */}
      <CommonDialog
        open={dialogBusinessScoreCardShowAllOpen}
        title={`Business Scorecard Overall Rating - ${B_overallRating}%`}
        cancelText='Close'
        hideSubmitBtn
        content={
          <TableCard
            // title="Scorecard Rating "
            // title={`'Scorecard Rating - overallRating' - ${overallRating}%`}
            header={["E-mail", "Rating", "Action"]}
            data={ideaSplit.bIdeas}
            HideEyeIconForOtherEvaluator={hasMatchingUserEvaluatorForBusiness}
            loginUserEmail={loginUserEmail}
            isEvaluator={isEvaluator}
            isAdmin={isAdmin}
            isOrganizer={isOrganizer}
            onClick={handleEvaluatorClick}
            disabled={DeleteAssignedEvaluatorIdeaIsLoading}
            hideShowAll
          />
        }
        onClose={() => setDialogBusinessScoreCardShowAllOpen(false)}
      />

      {selectedEvaluator && (
        <CommonDialog
          open={dialogEvaluatorOpen}
          title={`Scorecard - ${selectedEvaluator.userEmail}`}
          cancelText="Close"
          hideSubmitBtn
          content={
            <ReactFormGenerator
              data={JSON.parse(selectedEvaluator.scoreCardJson?.value || '[]')}
              answer_data={JSON.parse(selectedEvaluator.scoreCardAnswerJson?.value || '[]')}
              hide_actions
              read_only
            />
          }
          onClose={() => setDialogEvaluatorOpen(false)}
        />
      )}



      {/* this popup used for team search */}

      {/* Assign Evaluator Dialog */}
      <CommonDialog
        open={dialogOpenForTeamSearchAdd}
        title="Add Team Member 1"
        confirmText="Add Team"
        InviteButtonText="Invite Team"
        hideSubmitBtn={isOwner}
        hideInviteBtn
        content={
          <TagSelector
            isLoading={evaluationLoading}
            inputLabel="Search Add Team Member..."
            onValueChange={handleChildValueChange}
            getSuggestionsAPI={onUserEvaluatorSearchSuggestions}
            suggestionsList={userEvaluatorSuggestions}
            searchMode='user' //single search mode user for add team member
            hideCommunitySearch
          />
        }
        onClose={() => setDialogOpenForTeamSearchAdd(false)}
        onConfirm={handleAddTeamMemberConfirm}
        onInviteAction={onInviteTeamMemberFn}
        disabled={!childValueSelectedUserTags?.length}
      />


      <CommonDialog
        open={dialogOpenBusinessScorecard}
        title='Select Business Scorecard '
        cancelText="Close"
        hideSubmitBtn
        content={
          <BusinessScorecardList
            listScorecardTemplateLoading={listScorecardTemplateLoading}
            innovateAddBusinessScoreCardIsLoading={innovateAddBusinessScoreCardIsLoading}
            listScorecardTemplate={listScorecardTemplate}
            putAddBusinessScoreCardFn={putAddBusinessScoreCardFn}
            ideaIdKey={ideaIdKey}
            setDialogOpenBusinessScorecard={setDialogOpenBusinessScorecard}
            ChallengeTemplateId={ChallengeTemplateId}
            businessScoreCardTemplateId={businessScoreCardTemplateId}
          />
        }
        onClose={() => setDialogOpenBusinessScorecard(false)}
      />

    </>
  );
};

export default Dialogs;
